export default __webpack_public_path__ + "static/media/media-banner.008e7992.png";